import React, { useState } from 'react';
import cogoToast from 'cogo-toast';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/pro-light-svg-icons';

import { markSpotlightError } from '../../api/spotlights';

// Mirror of SPOTLIGHT_ERROR_REASONS (packages/universal/src/spotlights.js) — the admin app has no
// @shopmy/universal dependency, and the server re-validates the key, so this only seeds the dropdown.
const ERROR_REASONS = [
  { key: 'stuck_in_launching', label: 'Stuck in launching' },
  { key: 'not_monetized', label: 'Not monetized' },
  { key: 'other', label: 'Other' }
];

// Flag a single spotlight into the triage queue: pauses it if live and stamps the admin reason.
// The note is admin-only (creators/brands see a generic "under review" state).
const MarkSpotlightErroredModal = ({ onClose, onDone }) => {
  const [spotlightId, setSpotlightId] = useState('');
  const [errorType, setErrorType] = useState(ERROR_REASONS[0].key);
  const [reason, setReason] = useState('');
  const [saving, setSaving] = useState(false);

  const id = parseInt(spotlightId.trim(), 10);
  const canSubmit = !!id && !!reason.trim() && !saving;

  const submit = async () => {
    if (!canSubmit) return;
    setSaving(true);
    try {
      const r = await markSpotlightError(id, errorType, reason.trim());
      cogoToast.success(r.paused ? `Spotlight #${id} marked errored and paused` : `Spotlight #${id} marked errored`);
      onDone && onDone();
      onClose();
    } catch (e) {
      cogoToast.error(typeof e === 'string' ? e : 'Could not mark the spotlight errored.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className='sl-modal-overlay' onMouseDown={onClose}>
      <div className='sl-modal' onMouseDown={e => e.stopPropagation()}>
        <div className='sl-modal-head'>
          <div className='sl-modal-title'>Mark a spotlight errored</div>
          <button className='sl-modal-close' onClick={onClose}>
            <FontAwesomeIcon icon={faTimes} />
          </button>
        </div>

        <div className='sl-modal-body'>
          <div className='sl-trial-settings'>
            <label className='sl-trial-field'>
              <span>Spotlight ID</span>
              <input type='number' autoFocus placeholder='e.g. 12345' value={spotlightId} onChange={e => setSpotlightId(e.target.value)} />
            </label>
            <label className='sl-trial-field'>
              <span>Reason</span>
              <select value={errorType} onChange={e => setErrorType(e.target.value)}>
                {ERROR_REASONS.map(r => (
                  <option key={r.key} value={r.key}>
                    {r.label}
                  </option>
                ))}
              </select>
            </label>
          </div>

          <div className='sl-card-label' style={{ margin: '16px 0 8px' }}>
            Note (admin-only, required)
          </div>
          <textarea
            className='sl-vip-textarea'
            placeholder='What’s wrong and what you checked — visible to admins only.'
            value={reason}
            onChange={e => setReason(e.target.value)}
          />

          <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 14 }}>
            <button className='sl-btn' disabled={!canSubmit} onClick={submit}>
              {saving ? 'Marking…' : 'Mark errored'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MarkSpotlightErroredModal;
